import { Button, SnackbarContent, Typography, makeStyles } from '@material-ui/core';
import React, { ComponentType } from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  warning: {
    backgroundColor: '#fff',
    color: theme.palette.getContrastText('#fff'),
    boxShadow: theme.shadows[1],
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  number: {
    marginRight: theme.spacing(1),
  },
}));

type NumberOfCandidacyInfoMessageProps = {
  numberOfElement: number;
};

const NumberOfCandidacyInfoMessage: ComponentType<NumberOfCandidacyInfoMessageProps> = ({ numberOfElement }) => {
  const classes = useStyles();

  return (
    <SnackbarContent
      className={classes.warning}
      message={
        <span className={classes.message}>
          <Typography variant="h3" className={classes.number}>
            {numberOfElement}
          </Typography>
          abri(s) disponible(s) à la candidature
        </span>
      }
      action={
        <Button size="small" component={Link} to="/candidacies">
          Je candidate
        </Button>
      }
    />
  );
};

export default NumberOfCandidacyInfoMessage;
